/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MatchesInputs */

const en__field_matches = /** @type {(inputs: _Field_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matches`)
};

const de__field_matches = /** @type {(inputs: _Field_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matches`)
};

/**
* | output |
* | --- |
* | "Matches" |
*
* @param {_Field_MatchesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_matches = /** @type {((inputs?: _Field_MatchesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MatchesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_matches(inputs)
	return de__field_matches(inputs)
});